import React, {useMemo} from 'react'
import Plate from "../../Plate";
import DropDownPicker from "../../DropDownPicker";
import StarsIcon from "../../../assets/icon/StarsIcon";
import { TASK_PRIORITY_LIST } from "../../../utils/taskPriority";

interface TaskPriorityPickerProps {
    getPriority: (priorityId: string | number) => void
    priorityId: string | number
    onlyIcon?: boolean
    dropdownPosition?: 'left' | 'right' | 'side-right'
}

export default function TaskPriorityPicker({getPriority, priorityId, onlyIcon, dropdownPosition = 'left'}: TaskPriorityPickerProps) {
    const pickedPriority = useMemo(() => {
        return TASK_PRIORITY_LIST.find(({id}) => priorityId === id)
    }, [priorityId]);

    return (
        <DropDownPicker closeDropDownByPick={true}
                        pickerList={TASK_PRIORITY_LIST}
                        position={dropdownPosition}
                        getValue={getPriority}
                        btn={(isOpen: boolean) => onlyIcon ? (
                            <div>
                                {pickedPriority?.icon || <StarsIcon color={isOpen ? '#64617E' : '#B1AEC7'}/>}
                            </div>
                        ) :(
                            <Plate title={pickedPriority?.title || "Приоритет"}
                                   icon={pickedPriority?.icon || <StarsIcon color={isOpen ? '#64617E' : '#B1AEC7'}/>}
                                   active={isOpen}
                                   filled={!!pickedPriority}
                                   accentColor={pickedPriority?.color}/>
                        )}/>
    )
}
